import { STANDARD_PACKAGE_ID } from '../../../../../services/package-service';

const isCustomPackage = ({ isCustom }) => !!isCustom;

export const filterByServices = (sellerServices, selectedServiceId) => (pkg) => {
  const carrierIds = sellerServices.map((x) => x.carrierId);
  const uniqueCarriers = new Set(carrierIds);
  const multipleCarriersSelected = uniqueCarriers.size > 1;
  const showGenericPackagesOnly = !selectedServiceId && multipleCarriersSelected;
  const packageIsCustom = isCustomPackage(pkg);
  if (showGenericPackagesOnly) {
    return packageIsCustom || (pkg.packageTypeId === STANDARD_PACKAGE_ID && carrierIds.some((c) => c === pkg.carrierId));
  }

  if (selectedServiceId) {
    const selectedService = sellerServices.find((x) => x.serviceId === selectedServiceId);
    const selectedServiceCarrierId = selectedService ? selectedService.carrierId : 0;
    return packageIsCustom || pkg.carrierId === selectedServiceCarrierId;
  }
  return packageIsCustom || !carrierIds || carrierIds.length === 0 || carrierIds.some((c) => c === pkg.carrierId);
};
